import { useCallback, useMemo, useState } from "react";

/**
 * Selection state for a DataTable: a set of row keys that survives page
 * changes, so "select 3 on page 1, 2 on page 2, then bulk-act on 5" works.
 * Pass `selection` straight into `<DataTable selection={…}>`.
 */
export function useRowSelection(initial: Iterable<string> = []) {
	const [selected, setSelected] = useState<Set<string>>(() => new Set(initial));
	const clear = useCallback(() => setSelected(new Set()), []);
	const onChange = useCallback((next: Set<string>) => setSelected(next), []);
	return useMemo(
		() => ({ selected, onChange, clear, count: selected.size, ids: [...selected] }),
		[selected, onChange, clear],
	);
}
